import { render, staticRenderFns } from "./PrescriptionsBase.vue?vue&type=template&id=2e289f85"
import script from "./PrescriptionsBase.vue?vue&type=script&lang=js"
export * from "./PrescriptionsBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports